export const ErrorTypes = {
  SERVER_ERROR: "ERROR",
  CONFIRM_ERROR: "CONFIRM_ERROR",
};
